










import { Vue, Component, Prop } from "vue-property-decorator";
import AsideMenuItem from './AsideMenuItem.vue'

@Component({
  name: 'AsideMenuList',

  components: {
    AsideMenuItem
  }
})
export default class AsideMenuList extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  isSubmenuList;

  @Prop({
    type: Boolean,
    default: false
  })
  isSecondary;

  @Prop({
    type: Array,
    default: () => []
  })
  menu;

  menuClick(item) {
    this.$emit('menu-click', item)
  }
}
